var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg8":"","offset-md1":"","offset-lg2":""}},[_c('v-img',{attrs:{"src":_vm.stepImg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }